import { jsx as c } from "react/jsx-runtime";
import * as p from "react";
import { forwardRef as z } from "react";
import { c as m } from "./index-DLeNytVF.js";
import { u as O } from "./index-DLcqcWxM.js";
import { c as G } from "./index-UFb2E87s.js";
import { D as H } from "./index-Dz0AUfZX.js";
import { h as K, R as j, u as U, F as V } from "./index-BUY6qYfp.js";
import { u as W } from "./index-umR1UobZ.js";
import { c as _, C as Z, R as q, A as x, a as B } from "./index-Duz4GUys.js";
import { P as J } from "./index-CsGiVPqA.js";
import { P as w } from "./index-L6dgm95g.js";
import { c as Q, P as b } from "./index-BrTLHETv.js";
import { u as X } from "./index-DYfkNB0n.js";
import { $ as Y } from "./utils-CTvPli9r.js";
var C = "Popover", [E, Ne] = G(C, [
  _
]), P = _(), [ee, d] = E(C), N = (e) => {
  const {
    __scopePopover: n,
    children: t,
    open: a,
    defaultOpen: o,
    onOpenChange: r,
    modal: s = !1
  } = e, i = P(n), l = p.useRef(null), [u, g] = p.useState(!1), [h, f] = X({
    prop: a,
    defaultProp: o ?? !1,
    onChange: r,
    caller: C
  });
  return /* @__PURE__ */ c(q, { ...i, children: /* @__PURE__ */ c(
    ee,
    {
      scope: n,
      contentId: W(),
      triggerRef: l,
      open: h,
      onOpenChange: f,
      onOpenToggle: p.useCallback(() => f((R) => !R), [f]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: p.useCallback(() => g(!0), []),
      onCustomAnchorRemove: p.useCallback(() => g(!1), []),
      modal: s,
      children: t
    }
  ) });
};
N.displayName = C;
var F = "PopoverAnchor", y = p.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...a } = e, o = d(F, t), r = P(t), { onCustomAnchorAdd: s, onCustomAnchorRemove: i } = o;
    return p.useEffect(() => (s(), () => i()), [s, i]), /* @__PURE__ */ c(x, { ...r, ...a, ref: n });
  }
);
y.displayName = F;
var S = "PopoverTrigger", D = p.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...a } = e, o = d(S, t), r = P(t), s = O(n, o.triggerRef), i = /* @__PURE__ */ c(
      b.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": $(o.open),
        ...a,
        ref: s,
        onClick: m(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? i : /* @__PURE__ */ c(x, { asChild: !0, ...r, children: i });
  }
);
D.displayName = S;
var A = "PopoverPortal", [oe, te] = E(A, {
  forceMount: void 0
}), M = (e) => {
  const { __scopePopover: n, forceMount: t, children: a, container: o } = e, r = d(A, n);
  return /* @__PURE__ */ c(oe, { scope: n, forceMount: t, children: /* @__PURE__ */ c(w, { present: t || r.open, children: /* @__PURE__ */ c(J, { asChild: !0, container: o, children: a }) }) });
};
M.displayName = A;
var v = "PopoverContent", T = p.forwardRef(
  (e, n) => {
    const t = te(v, e.__scopePopover), { forceMount: a = t.forceMount, ...o } = e, r = d(v, e.__scopePopover);
    return /* @__PURE__ */ c(w, { present: a || r.open, children: r.modal ? /* @__PURE__ */ c(ne, { ...o, ref: n }) : /* @__PURE__ */ c(ae, { ...o, ref: n }) });
  }
);
T.displayName = v;
var re = Q("PopoverContent.RemoveScroll"), ne = p.forwardRef(
  (e, n) => {
    const t = d(v, e.__scopePopover), a = p.useRef(null), o = O(n, a), r = p.useRef(!1);
    return p.useEffect(() => {
      const s = a.current;
      if (s) return K(s);
    }, []), /* @__PURE__ */ c(j, { as: re, allowPinchZoom: !0, children: /* @__PURE__ */ c(
      k,
      {
        ...e,
        ref: o,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: m(e.onCloseAutoFocus, (s) => {
          var i;
          s.preventDefault(), r.current || (i = t.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: m(
          e.onPointerDownOutside,
          (s) => {
            const i = s.detail.originalEvent, l = i.button === 0 && i.ctrlKey === !0, u = i.button === 2 || l;
            r.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: m(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), ae = p.forwardRef(
  (e, n) => {
    const t = d(v, e.__scopePopover), a = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ c(
      k,
      {
        ...e,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          var s, i;
          (s = e.onCloseAutoFocus) == null || s.call(e, r), r.defaultPrevented || (a.current || (i = t.triggerRef.current) == null || i.focus(), r.preventDefault()), a.current = !1, o.current = !1;
        },
        onInteractOutside: (r) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, r), r.defaultPrevented || (a.current = !0, r.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = r.target;
          ((u = t.triggerRef.current) == null ? void 0 : u.contains(s)) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && o.current && r.preventDefault();
        }
      }
    );
  }
), k = p.forwardRef(
  (e, n) => {
    const {
      __scopePopover: t,
      trapFocus: a,
      onOpenAutoFocus: o,
      onCloseAutoFocus: r,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: i,
      onPointerDownOutside: l,
      onFocusOutside: u,
      onInteractOutside: g,
      ...h
    } = e, f = d(v, t), R = P(t);
    return U(), /* @__PURE__ */ c(
      V,
      {
        asChild: !0,
        loop: !0,
        trapped: a,
        onMountAutoFocus: o,
        onUnmountAutoFocus: r,
        children: /* @__PURE__ */ c(
          H,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: g,
            onEscapeKeyDown: i,
            onPointerDownOutside: l,
            onFocusOutside: u,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ c(
              Z,
              {
                "data-state": $(f.open),
                role: "dialog",
                id: f.contentId,
                ...R,
                ...h,
                ref: n,
                style: {
                  ...h.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), I = "PopoverClose", se = p.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...a } = e, o = d(I, t);
    return /* @__PURE__ */ c(
      b.button,
      {
        type: "button",
        ...a,
        ref: n,
        onClick: m(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
se.displayName = I;
var ce = "PopoverArrow", ie = p.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...a } = e, o = P(t);
    return /* @__PURE__ */ c(B, { ...o, ...a, ref: n });
  }
);
ie.displayName = ce;
function $(e) {
  return e ? "open" : "closed";
}
var pe = N, le = y, ue = D, de = M, L = T;
const Fe = pe, ye = ue, Se = le, fe = z(({ className: e, align: n = "center", sideOffset: t = 4, ...a }, o) => /* @__PURE__ */ c(de, { children: /* @__PURE__ */ c(
  L,
  {
    ref: o,
    align: n,
    sideOffset: t,
    className: Y(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...a
  }
) }));
fe.displayName = L.displayName;
export {
  Fe as Popover,
  Se as PopoverAnchor,
  fe as PopoverContent,
  ye as PopoverTrigger
};
//# sourceMappingURL=popover.js.map
